import React, { useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icons from './Icons';

export default function PublicFooter() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = useCallback((type, target) => {
    if (type === 'top') {
      if (location.pathname === '/') window.scrollTo({ top: 0, behavior: 'smooth' });
      else navigate('/');
    } else if (type === 'scroll') {
      if (location.pathname === '/') {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate('/', { state: { scrollTo: target } });
      }
    }
  }, [location.pathname, navigate]);

  const quickLinks = [
    { label: 'Home', type: 'top' },
    { label: 'About', type: 'scroll', id: 'about' },
    { label: 'Programmes', type: 'route', path: '/programmes' },
    { label: 'Why Trees', type: 'route', path: '/tree-benefits' },
    { label: 'Gallery', type: 'route', path: '/gallery' },
    { label: 'Contributors', type: 'route', path: '/contributors' },
    { label: 'Collaboration', type: 'route', path: '/collaboration' },
    { label: 'Impact', type: 'scroll', id: 'impact' },
    { label: 'Contact', type: 'scroll', id: 'contact' },
  ];

  return (
    <footer id="contact" className="footer" style={{ background: '#0d3311', color: 'rgba(255,255,255,0.85)', padding: '80px 20px 0' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))', gap: 40, paddingBottom: 50 }}>
        {/* Column 1: Logo */}
        <div>
          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <img src={`${process.env.PUBLIC_URL || ''}/haritanjali_logo.png`} alt="Haritanjali" style={{ width: 58, height: 58, objectFit: 'contain' }} />
              <div>
                <div style={{ fontSize: 26, fontWeight: 800, lineHeight: 1.1 }}>हरितांजलि</div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.7)', letterSpacing: 3, textTransform: 'uppercase', fontWeight: 600, marginTop: 2 }}>HARITANJALI</div>
                <div style={{ fontSize: 12, color: '#F5A623', fontStyle: 'italic', marginTop: 3 }}>जहाँ पेड़, वहाँ जीवन</div>
              </div>
            </div>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, fontSize: 15, marginBottom: 24 }}>
            India's comprehensive digital platform for combating climate change through locally appropriate plantation activities.
          </p>
          <div style={{ display: 'flex', gap: 12 }}>
            {['Twitter', 'LinkedIn', 'Instagram'].map(social => (
              <div key={social} style={{
                width: 36, height: 36, borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                fontSize: 13, color: 'rgba(255,255,255,0.7)', cursor: 'pointer', transition: 'all 0.2s',
              }}>{social.charAt(0)}</div>
            ))}
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div>
          <h4 style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, color: '#fff' }}>Quick Links</h4>
          {quickLinks.map(link => (
            link.type === 'route' ? (
              <Link key={link.label} to={link.path} className="footer-link" style={{
                display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: 15,
                padding: '6px 0', transition: 'color 0.2s',
              }}>{link.label}</Link>
            ) : (
              <button key={link.label} onClick={() => handleNavClick(link.type, link.id)} className="footer-link" style={{
                display: 'block', background: 'none', border: 'none',
                color: 'rgba(255,255,255,0.6)', fontSize: 15,
                padding: '6px 0', cursor: 'pointer', transition: 'color 0.2s', textAlign: 'left',
              }}>{link.label}</button>
            )
          ))}
        </div>

        {/* Column 3: For Stakeholders */}
        <div>
          <h4 style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, color: '#fff' }}>For Stakeholders</h4>
          {[
            { label: 'CSR Entities', to: '/register' },
            { label: 'Individuals', to: '/register' },
            { label: 'Implementing Agencies', to: '/register' },
            { label: 'Login to Dashboard', to: '/login' },
          ].map(item => (
            <Link key={item.label} to={item.to} className="footer-link" style={{
              display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: 15,
              padding: '6px 0', transition: 'color 0.2s',
            }}>{item.label}</Link>
          ))}
        </div>

        {/* Column 4: Contact */}
        <div>
          <h4 style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, color: '#fff' }}>Contact Us</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, color: 'rgba(255,255,255,0.6)', fontSize: 14, lineHeight: 1.5 }}>
              <Icons.MapPin />
              <span>Ground Floor, Mohan Cooperative, A-32, Block B, Mohan Cooperative Industrial Estate, Badarpur, New Delhi, Delhi 110044</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'rgba(255,255,255,0.6)', fontSize: 15 }}>
              <Icons.Mail />
              <span>contact@haritanjali.org</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'rgba(255,255,255,0.6)', fontSize: 15 }}>
              <Icons.Phone />
              <span>+91 11-49050111</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', padding: '24px 20px', textAlign: 'center', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14 }}>
            &copy; {new Date().getFullYear()} हरितांजलि (Haritanjali). All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: 20 }}>
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map(p => (
              <span key={p} style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, cursor: 'pointer' }}>{p}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
